// Catálogo de comandos reales de ᵁᴺᴿ⚝ WARDEN, organizado por categoría para el
// "Centro Interactivo del Catálogo de Comandos" de la landing page.
// Los `response` de los comandos marcados `detailed:true` reproducen el
// formato EXACTO que devuelve el bot (ver /app/bot/commands/*.js y format.js).
// El resto usa un formato estándar coherente con el mismo lenguaje visual.
// Todo es contenido ESTÁTICO/DEMOSTRATIVO -- no hay conexión real a WhatsApp.

const DIV = '━━━━━━━━━━━━━━━━━━━━━━';

function std(icon, title, body) {
  return `${icon} **${title}**\n${DIV}\n${body}`;
}

export const COMMAND_CATEGORIES = [
  {
    id: 'guerra_cwl',
    label: 'Guerra y CWL',
    emoji: '⚔️',
    color: 'crimson',
    commands: [
      {
        cmd: '!war', desc: 'Estado de guerra actual', detailed: true,
        response: '⚔️ **Estado de Guerra**\n' + DIV + '\n⚔️ En guerra   (15v15)\n\n🟢 **Imperio Hispano**\n   ⭐ 42   💥 94.2%   🗡️ 28/30\n\n🔴 **Dragones del Norte**\n   ⭐ 39   💥 88.5%   🗡️ 26/30\n\n⏳ Termina en: 2h 14m',
      },
      {
        cmd: '!attacks', desc: 'Ataques pendientes', detailed: true,
        response: '🗡️ **Ataques Pendientes**  (4)\n\n🟢 **Imperio Hispano**\n   ⭐ 42   💥 94.2%   🗡️ 28/30\n\n🔴 **Dragones del Norte**\n   ⭐ 39   💥 88.5%   🗡️ 26/30\n\n⏳ Termina en: 2h 14m\n' + DIV + '\n#3 Carlos_CoC (TH15) — faltan 2\n#7 ShadowNinja (TH14) — faltan 1\n#12 Valquiria_Top (TH16) — faltan 1',
      },
      {
        cmd: '!top', desc: 'Mejores atacantes', detailed: true,
        response: '🏆 **Mejores Atacantes**\n\n🟢 Imperio Hispano vs 🔴 Dragones del Norte\n' + DIV + '\n🥇 #1 KingArthur_CoC — ⭐ 6 · 💥 200.0% (2 atq)\n🥈 #5 Valquiria_Top — ⭐ 5 · 💥 178.4% (2 atq)\n🥉 #9 Nocturno77 — ⭐ 5 · 💥 165.0% (2 atq)\n4. ShadowNinja — ⭐ 4 · 💥 152.0% (2 atq)',
      },
      {
        cmd: '!failed', desc: 'Ataques fallidos',
        response: std('❌', 'Ataques Fallidos (menos de 3⭐)  (2)', '#8 Nocturno77 → #14 GrimReaper: ⭐⭐☆ (78.5%)\n#20 LunaGrey → #4 BlackWolf: ⭐☆☆ (52.0%)'),
      },
      {
        cmd: '!cleanup', desc: 'Limpieza pendiente', detailed: true,
        response: '🧹 **Limpieza Pendiente**  (3)\n\n🟢 Imperio Hispano vs 🔴 Dragones del Norte\n' + DIV + '\n#4 BlackWolf (TH15) — ⭐⭐☆\n#11 IronFist (TH16) — sin atacar\n#18 ColdSteel (TH14) — ⭐☆☆',
      },
      {
        cmd: '!warmap', desc: 'Mapa de guerra por posición (rival espejo + mejor golpe recibido)',
        response: std('🗺️', 'Mapa de Guerra', '#1 🟢 KingArthur_CoC (TH16) ⭐⭐⭐ vs 🔴 Warlord_X (TH16) ⭐⭐☆\n#2 🟢 Valquiria_Top (TH15) ⭐⭐☆ vs 🔴 NightFury (TH15) ☆☆☆'),
      },
      {
        cmd: '!attackmap', desc: 'Línea de tiempo de todos los ataques (orden cronológico)',
        response: std('🕒', 'Línea de Tiempo de Ataques', '🟢 #1 #3 Carlos_CoC → #14 GrimReaper: ⭐⭐⭐ (100%)\n🔴 #2 #9 Warlord_X → #5 Valquiria_Top: ⭐⭐☆ (81%)'),
      },
      {
        cmd: '!analysis', desc: 'Análisis de guerra', detailed: true,
        response: '🔬 **Análisis de Guerra**\n' + DIV + '\n\n🟢 Imperio Hispano  ⭐42  💥94.2%\n🔴 Dragones del Norte  ⭐39  💥88.5%\n' + DIV + '\n🟢 Composición: TH16×8 TH15×5 TH14×2   ⭐/atq: **2.10**\n🔴 Composición: TH16×7 TH15×6 TH14×2   ⭐/atq: **1.95**\n📊 Diferencia de estrellas: **+3**\n🟢 Vamos al frente',
      },
      {
        cmd: '!forecast', desc: 'Pronóstico de victoria', detailed: true,
        response: '🔮 **Pronóstico de Victoria**\n' + DIV + '\n\n🟢 Imperio Hispano vs 🔴 Dragones del Norte\n' + DIV + '\n📈 Proyección: 🟢 44 - 🔴 41 (de 45)\n📊 Probabilidad de victoria: **76%**\n█████████████░\n\n🟢 Victoria probable',
      },
      {
        cmd: '!attendance', desc: '% de asistencia a guerras del mes por miembro',
        response: std('📋', 'Asistencia de Guerra — Mes Actual', '🟢 KingArthur_CoC (TH16) — **100%** (4/4 guerras)\n🟡 Nocturno77 (TH14) — **50%** (2/4 guerras)'),
      },
      {
        cmd: '!forceresumen', desc: 'Envía de inmediato el resumen de ataques pendiente (modo resumen)',
        response: std('📋', 'Resumen de Ataques (forzado manualmente)', '🟢 Nuestro clan (2):\n🟢 #3 Carlos_CoC → #14 GrimReaper\n   ⭐⭐⭐ (100%)\n\n🔴 Rival (1):\n🔴 #9 Warlord_X → #5 Valquiria_Top\n   ⭐⭐☆ (81%)'),
      },
      {
        cmd: '!warfull', desc: 'Detalle de todos los participantes y sus ataques (o "Pendiente de Atacar")',
        response: std('📋', 'Detalle de Guerra', '#1 KingArthur_CoC (TH16)\n   → #1 ⭐⭐⭐ 100%\n#2 ShadowNinja (TH14)\n   🔴 Pendiente de Atacar'),
      },
      {
        cmd: '!cwltop', desc: 'Top CWL', detailed: true,
        response: '🏆 **Top CWL**\n' + DIV + '\n🥇 KingArthur_CoC — ⭐ 15 · 💥 98% (5 atq)\n🥈 Valquiria_Top — ⭐ 13 · 💥 91% (5 atq)\n🥉 ShadowNinja — ⭐ 12 · 💥 87% (5 atq)',
      },
      {
        cmd: '!cwlsummary', desc: 'Resumen CWL Actual',
        response: std('📅', 'Resumen CWL Actual', '🏆 Liga: Julio 2026\n⚔️ Guerras finalizadas: **4/7**\n🟢 3  🔴 1  🟡 0\n⭐ Estrellas acumuladas: **156**'),
      },
      {
        cmd: '!cwlfinal', desc: 'Clasificación/MVP y resumen final de temporada CWL', detailed: true,
        response: '🏆 **CLASIFICACIÓN CWL — En curso** 🏆\n' + DIV + '\n🏅 Liga: **CAMPEONES 1**\n🗓️ Temporada: 2026-07\n🟢 **Imperio Hispano**\n📊 Posición: **#1** de 8\n⭐ Estrellas totales: **156**   💥 92%\n🔥 Mejor racha: **4** victoria(s) seguida(s)\n🔼 Proyección: zona de ASCENSO\n\n📋 Clasificación de la liga:\n🥇 Imperio Hispano — ⭐ 156 · 💥 92%\n🥈 Dragones del Norte — ⭐ 148 · 💥 89%\n\n🌟 Mejores atacantes del clan:\n🏅 MVP KingArthur_CoC (TH16) — ⭐ 15 en 5 atq · prom 98%\n\n👑 Rey del pleno: KingArthur_CoC (TH16) — 5 ataque(s) de 3⭐',
      },
      {
        cmd: '!honor', desc: 'Cuadro de honor CWL (campeones de temporadas anteriores)',
        response: std('🏛️', 'CUADRO DE HONOR CWL', '🗓️ 2026-06 — 🥇 de 8 · ⭐ 152\n   🏅 MVP: KingArthur_CoC (⭐15)\n   👑 Rey del pleno: KingArthur_CoC (5×3⭐)'),
      },
      {
        cmd: '!liga=N', desc: 'Resultado histórico de la ronda N de la última CWL registrada',
        response: std('🏆', 'CWL Ronda 3 — Temporada 2026-07', '🟢 Imperio Hispano  vs  🔴 Titanes de Acero\n⭐ 15 - 12   💥 98.0% - 85.0%\nResultado: ✅ Victoria 💯 PERFECTA'),
      },
    ],
  },
  {
    id: 'leyendas_rankeds',
    label: 'Leyendas y Rankeds',
    emoji: '🏆',
    color: 'gold',
    commands: [
      {
        cmd: '!ranked #TAG', desc: 'Clasificación Ranked, información de usuario y top global y local del jugador', detailed: true,
        response: '⚡ **Ranked — Electro League 32**\n' + DIV + '\n👤 **Nocturno77**  `#Q8GCLLY0G`\n🏆 Copas: **5,214**\n📈 Hoy: **+38** (2 atq, 1 def)\n🌍 Ranking país: **#412** 🇲🇽\n🏠 Ranking clan: **#3**',
      },
      {
        cmd: '!rankedclan #TAG', desc: 'Clasificación de Ranked del clan mes anterior',
        response: std('⚡', 'Ranked del Clan — Mes Anterior', '🥇 Nocturno77 — ⚡ Electro 32 — 5,214🏆\n🥈 LunaGrey — 🐉 Dragon 28 — 4,890🏆'),
      },
      {
        cmd: '!legend #TAG', desc: 'Estado actual (Copas, racha, ranking) en Legend o en su liga Ranked', detailed: true,
        response: '👑 **Liga Leyenda — Temporada Actual**\n' + DIV + '\n👤 **KingArthur_CoC**  `#92VY80QQ`\n🏆 Copas actuales: **5,912**\n📈 Balance de hoy: **+40** (1 atq, 0 def)\n🔥 Racha positiva: **6 días**\n🌍 Ranking país: **#87** 🇪🇸',
      },
      {
        cmd: '!legendseason #TAG', desc: 'Detalle día por día de la temporada en curso',
        response: std('📅', 'Temporada Legend — Día por Día', '10 ago: +40 (⭐ 1 atq)\n11 ago: +34 (⭐ 1 atq, 1 def)\n12 ago: +40 (⭐ 1 atq)'),
      },
      {
        cmd: '!legendclan', desc: 'Tabla de todos los miembros rastreados del clan (Legend + Ranked)', detailed: true,
        response: '🏆 **Legend/Ranked del Clan**\n' + DIV + '\n👑 KingArthur_CoC — Legend — 5,912🏆 (+40 hoy)\n👑 Valquiria_Top — Legend — 5,748🏆 (+12 hoy)\n⚡ Nocturno77 — Electro 32 — 5,214🏆 (+38 hoy)\n🐉 LunaGrey — Dragon 28 — 4,890🏆 (−6 hoy)',
      },
    ],
  },
  {
    id: 'capital_clan',
    label: 'Capital del Clan',
    emoji: '🏰',
    color: 'gold',
    commands: [
      {
        cmd: '!capital', desc: 'Capital del clan', detailed: true,
        response: '🏛️ **Capital del Clan**\n' + DIV + '\n📅 Estado: En curso\n💰 Botín total: **48,750**\n⚔️ Asaltos completados: **18**\n🗡️ Ataques totales: **86**\n🏘️ Distritos destruidos: **22**\n\n🔴 Ataques pendientes (6):\n  • ShadowNinja — faltan 3\n\n🏆 Top 3 saqueadores:\n  🥇 KingArthur_CoC — 3,750 💰 (6/6)\n  🥈 Valquiria_Top — 3,600 💰 (6/6)',
      },
      {
        cmd: '!top capital', desc: 'Top saqueadores del último asalto a Capital',
        response: std('🏆', 'Top Saqueadores — Capital', '🥇 KingArthur_CoC — 3,750 💰 (6/6)\n🥈 Valquiria_Top — 3,600 💰 (6/6)\n🥉 Nocturno77 — 3,420 💰 (6/6)'),
      },
      {
        cmd: '!capitalmvp', desc: 'Ranking de mayor botín acumulado en Capital', detailed: true,
        response: '👑 **Capital MVP — Histórico**\n' + DIV + '\n🥇 KingArthur_CoC — 142,600💰 (24 finde(s), 138 ataques)\n🥈 Valquiria_Top — 138,900💰 (24 finde(s), 141 ataques)\n🥉 Nocturno77 — 121,050💰 (23 finde(s), 132 ataques)',
      },
      {
        cmd: '!capitalghost', desc: 'Miembros que más faltan a los asaltos de Capital',
        response: std('👻', 'Fantasmas de Capital — Histórico', '1. ColdSteel — 5/24 finde(s) sin atacar\n2. IronFist — 3/24 finde(s) sin atacar'),
      },
    ],
  },
  {
    id: 'gestion_comunidad',
    label: 'Gestión y Comunidad',
    emoji: '👥',
    color: 'blue',
    commands: [
      {
        cmd: '!clan', desc: 'Info del clan', detailed: true,
        response: '🏰 **Imperio Hispano**  `#2PP`\n' + DIV + '\n🏅 Nivel: **19**   👥 Miembros: **48/50**\n🏆 Puntos: **52,410**   🏛️ Capital: **21,300**\n⚔️ Liga de guerra: **Campeones I**\n📊 Guerras — 🟢 214  🔴 62  🟡 5\n🔥 Racha victorias: **6**\n🌍 Ubicación: México',
      },
      {
        cmd: '!player #TAG', desc: 'Info de jugador', detailed: true,
        response: '👤 **KingArthur_CoC**  `#92VY80QQ`\n' + DIV + '\n🏛️ TH16   ⭐ Exp: 245\n🏆 Trofeos: **5,912** (récord 5,940)\n⚔️ Estrellas de guerra: **1,845**\n🎖️ Rol: Colíder\n🏰 Clan: Imperio Hispano `#2PP`\n📤 Donaciones: 4,120   📥 Recibidas: 2,980\n\n📊 Progreso basado en la API: 96%\n🦸 Héroes: 96%\n🐾 Mascotas: 90%\n⚔️ Tropas: 98%\n🔮 Hechizos: 94%\n🛡️ Equipamientos: 88%',
      },
      {
        cmd: '!leaderboard', desc: 'Tabla de líderes',
        response: std('📊', 'Tabla de Líderes — Imperio Hispano', '🥇 KingArthur_CoC — 🏆 5,912  📤 4,120\n🥈 Valquiria_Top — 🏆 5,748  📤 3,890'),
      },
      {
        cmd: '!rules', desc: 'Reglas del clan',
        response: std('📜', 'Reglas del Clan', '1. Dona diario, mínimo 1 vez por semana.\n2. Ataca en cada guerra, sin excusas.\n3. Respeto entre miembros, cero toxicidad.'),
      },
      {
        cmd: '!setrules <texto>', desc: 'Definir/actualizar las reglas del clan',
        response: std('✅', 'Reglas Actualizadas', 'Los miembros ya pueden verlas con **!rules**.'),
      },
      {
        cmd: '!events', desc: 'Calendario de eventos del mes',
        response: std('📅', 'Calendario de Eventos del Mes', 'Se envía la imagen fijada por el administrador con todos los eventos, torneos y fechas clave del mes.'),
      },
      {
        cmd: '!rival', desc: 'Info del rival', detailed: true,
        response: '🎯 **Rival Actual**\n' + DIV + '\n⚔️ Imperio Hispano vs Dragones del Norte\n' + DIV + '\n🔴 **Dragones del Norte**  `#8LR`\n⭐ Estrellas: 39   💥 88.5%\n🗡️ Ataques usados: 26',
      },
      {
        cmd: '!rivalfull', desc: 'Información completa del rival',
        response: std('📖', 'Información Completa del Rival', '🔴 Dragones del Norte `#8LR`\n🏅 Nivel: 17   👥 Miembros: 49/50\n⚔️ Liga de guerra: Campeones I\n📊 Guerras — 🟢 198 🔴 70 🟡 3'),
      },
      {
        cmd: '!rivalsummary', desc: 'Resumen del rival',
        response: std('📊', 'Resumen del Rival', '🔴 Dragones del Norte\n⭐ 39   💥 88.5%\n🏛️ Composición: TH16×7 TH15×6 TH14×2'),
      },
      {
        cmd: '!rivalmembers', desc: 'Miembros del rival',
        response: std('👥', 'Miembros del Rival — Dragones del Norte', '#1 Warlord_X — TH16\n#2 NightFury — TH15'),
      },
      {
        cmd: '!rivalhelp', desc: 'Ayuda sobre comandos del rival',
        response: std('🎯', 'Ayuda — Comandos de Rival CWL', '!rival, !rivalfull, !rivalsummary, !rivalmembers.\nEl rival se detecta de la guerra regular o de la CWL en curso.'),
      },
    ],
  },
  {
    id: 'legado_gamificacion',
    label: 'Legado y Gamificación',
    emoji: '🏛️',
    color: 'crimson',
    commands: [
      {
        cmd: '!king', desc: 'Ranking de mayor cantidad de estrellas acumuladas', detailed: true,
        response: '👑 **Rey de Guerra — Histórico (365 días)**\n' + DIV + '\n👑 KingArthur_CoC — 1,845⭐ (612 perfectos, 645 ataques)\n🥈 Valquiria_Top — 1,690⭐ (540 perfectos, 610 ataques)\n🥉 Nocturno77 — 1,520⭐ (480 perfectos, 590 ataques)',
      },
      {
        cmd: '!loser', desc: 'Ranking de menor promedio de estrellas (mín. 3 ataques)',
        response: std('😅', 'Necesita Práctica — Histórico', '1. ColdSteel — 1.42⭐ promedio (18 ataques)\n2. IronFist — 1.58⭐ promedio (22 ataques)'),
      },
      {
        cmd: '!bestattack', desc: 'El mejor ataque registrado del clan',
        response: std('🌟', 'Mejor Ataque Histórico', 'KingArthur_CoC (TH16) → GrimReaper (TH16)\n⭐⭐⭐ (100.0%)\n🗓️ 12/07/2026'),
      },
      {
        cmd: '!worstattack', desc: 'El peor ataque registrado del clan',
        response: std('🪦', 'Peor Ataque Histórico', 'ColdSteel (TH14) → IronWall (TH15)\n☆☆☆ (8.0%)\n🗓️ 03/06/2026'),
      },
      {
        cmd: '!perfect', desc: 'Guerras perfectas (3⭐ en todos los ataques)',
        response: std('💯', 'Guerras Perfectas — Histórico', 'Total: **7**\n✅ vs Titanes de Acero — 12/07/2026 (CWL)\n✅ vs Furia Roja — 28/05/2026'),
      },
      {
        cmd: '!halloffame', desc: 'Ranking de más ataques de 3 estrellas', detailed: true,
        response: '🏛️ **Salón de la Fama — Histórico**\n' + DIV + '\n🏆 KingArthur_CoC — 612 ataques perfectos (de 645 totales)\n🥈 Valquiria_Top — 540 ataques perfectos (de 610 totales)\n🥉 Nocturno77 — 480 ataques perfectos (de 590 totales)',
      },
      {
        cmd: '!hallofshame', desc: 'Ranking de más ataques de 0 estrellas (opcional: !hallofshame 1, !hallofshame 2)',
        response: std('🚫', 'Salón de la Vergüenza — 0⭐', '1. ColdSteel — 6 ataques de 0⭐ (de 18 totales)\n2. IronFist — 4 ataques de 0⭐ (de 22 totales)'),
      },
      {
        cmd: '!wall', desc: 'Ranking de mejores defensores (menos estrellas concedidas)',
        response: std('🧱', 'El Muro — Mejores Defensores', '1. 🧱 KingArthur_CoC — 0.85⭐ concedidas en promedio (40 defensas)\n2. 🧱 Valquiria_Top — 1.02⭐ concedidas en promedio (38 defensas)'),
      },
      {
        cmd: '!wallfail', desc: 'Ranking de peores defensores (más estrellas concedidas)',
        response: std('🕳️', 'Muro de Cristal — Peores Defensores', '1. 🕳️ ColdSteel — 2.80⭐ concedidas en promedio (25 defensas)\n2. 🕳️ IronFist — 2.65⭐ concedidas en promedio (28 defensas)'),
      },
      {
        cmd: '!duel #TAG1 #TAG2', desc: 'Compara el historial de dos miembros', detailed: true,
        response: '⚔️ **Duelo Histórico**\n' + DIV + '\nKingArthur_CoC: 1,845⭐ · promedio 2.86 · 612 perfectos · 645 ataques\nValquiria_Top: 1,690⭐ · promedio 2.77 · 540 perfectos · 610 ataques\n\n🏆 Ganador: **KingArthur_CoC**',
      },
      {
        cmd: '!legacy #TAG', desc: 'Ficha histórica completa de un miembro',
        response: std('📜', 'Legado de KingArthur_CoC', '🗓️ Guerras registradas: 645\n⚔️ Ataques: 645   ⭐ Estrellas: 1,845\n💥 Destrucción total: 92.4%\n✅ Perfectos (3⭐): 612   ❌ Ceros: 4'),
      },
      {
        cmd: '!month', desc: 'Mes Actual', detailed: true,
        response: '📊 **Reporte de Guerra — Mes Actual**\n' + DIV + '\n⚔️ Guerras jugadas: **8**\n🟢 Victorias: **7**   🔴 Derrotas: **1**   🟡 Empates: **0**\n📈 % Victorias: **88%**\n⭐ Estrellas totales: **336**\n💥 Destrucción media: **91.2%**\n\n🌟 Mejores atacantes del clan:\n🏅 MVP KingArthur_CoC (TH16) — ⭐ 46 en 16 atq · prom 96%',
      },
      {
        cmd: '!previousmonth', desc: 'Mes anterior',
        response: std('📊', 'Reporte de Guerra — Mes Anterior', '⚔️ Guerras jugadas: **9**\n🟢 Victorias: **8**   🔴 Derrotas: **1**\n📈 % Victorias: **89%**\n⭐ Estrellas totales: **381**'),
      },
    ],
  },
  {
    id: 'avisos_configuracion',
    label: 'Avisos y Configuración',
    emoji: '⚙️',
    color: 'blue',
    commands: [
      {
        cmd: '!ac', desc: 'Menú rápido: elige el comando por letra (sin escribirlo)', detailed: true,
        response: '🤖 **ᵁᴺᴿ⚝ WARDEN — Selección de Comandos**\n' + DIV + '\n👉 Responde con la letra del comando (ej: **a**).\n\n**⚔️ Guerra**\na) !war — Estado de guerra actual\nb) !attacks — Ataques pendientes\nc) !top — Mejores atacantes\n\n**🏆 Ranked**\nq) !ranked — Ranked de un jugador _(pide #TAG)_',
      },
      {
        cmd: '!notify on/off', desc: 'Activar/desactivar avisos de ataques (allies/both)',
        response: std('🔔', 'Avisos Actualizados', 'Avisos de ataques **ACTIVADOS ✅**.'),
      },
      {
        cmd: '!notifymode instant/summary', desc: 'instant notifica breve el resultado del ataque, summary notifica un resumen según el tiempo asignado con !notifytime',
        response: std('⚙️', 'Modo de Avisos', 'Modo de avisos: **Resumen**.\nEl resumen se enviará cada 1h (ajusta con !notifytime=N).'),
      },
      {
        cmd: '!notifytime=N', desc: 'notificar el resumen cada N horas (ej. cada 1 hora). Si no hubo ataques no notifica.',
        response: std('⏱️', 'Intervalo Configurado', 'Resumen configurado **cada 2h**. Modo cambiado a **Resumen**.'),
      },
      {
        cmd: '!notifywar on/off', desc: 'Avisar inicio y fin de la guerra', detailed: true,
        response: '⏳ **¡La Guerra termina en ~2h!**\n' + DIV + '\n⚔️ Imperio Hispano vs Dragones del Norte\n\n🔴 **Ataques pendientes (4):**\n  • Carlos_CoC (TH15) — faltan 2\n  • ShadowNinja (TH14) — faltan 1\n  • Valquiria_Top (TH16) — faltan 1\n\n¡No dejen ataques sin usar! 🗡️',
      },
      {
        cmd: '!notifywartime=N', desc: 'recordar N horas antes: castillos (al iniciar) y ataques pendientes (al finalizar)',
        response: std('⚔️', 'Recordatorios de Guerra', 'Configurados **2h antes**.\n🏰 2h antes de iniciar: recordatorio de castillos.\n⏳ 2h antes de finalizar: ataques pendientes.'),
      },
      {
        cmd: '!commentsattacks on/off', desc: 'Comentarios automáticos según las estrellas (solo ataques del clan)',
        response: std('💬', 'Comentarios de Ataques', '**ACTIVADOS ✅**.\nSe añadirá un comentario según las estrellas a cada ataque del clan.'),
      },
      {
        cmd: '!statusnotify', desc: 'Estado e información activado', detailed: true,
        response: '🔔 **Estado de Avisos**\n' + DIV + '\n📢 Avisos de ataques: **✅ ACTIVADO**\n🎯 Alcance: **Ambos (aliados + rivales)**\n⚙️ Modo: **Resumen**\n⏱️ Intervalo resumen: **cada 2h**\n👥 Avisos nuevos miembros: **✅ ACTIVADO**\n⚔️ Avisos de guerra/CWL: **✅ ACTIVADO** (recordatorios 2h antes)\n💬 Comentarios de ataques: **✅ ACTIVADO**',
      },
      {
        cmd: '!membernotice on/off', desc: 'Activar/desactivar avisos de nuevos miembros y salida de miembros en el clan',
        response: std('👥', 'Avisos de Miembros', 'Avisos de nuevos miembros **ACTIVADOS ✅**.'),
      },
      {
        cmd: '!license', desc: 'Ver tu plan y tiempo restante',
        response: std('💳', 'Tu Plan — ᵁᴺᴿ⚝ WARDEN', '✅ Estado: **ACTIVO**\n📅 Activado: 01/07/2026\n⌛ Expira: 01/08/2026\n⏳ Tiempo restante: **28 días, 4 horas y 12 minutos**'),
      },
      {
        cmd: '!redeem CODIGO', desc: 'Canjear un código de renovación (ej. !redeem ACW-7F3K-9QLM)',
        response: std('✅', 'Código Canjeado', 'Tu plan fue renovado exitosamente. ¡Gracias por seguir con ᵁᴺᴿ⚝ WARDEN! 🛡️'),
      },
    ],
  },
];

export const TOTAL_COMMANDS = COMMAND_CATEGORIES.reduce((s, c) => s + c.commands.length, 0);
